import { useTranslation } from 'react-i18next'
import { UpcomingPayroll } from '../../../../../redux/types'
import { formatDateString } from '../../../../../util/date'
import { PayrollHeader, StatusMessage, ImportFilesForPayday, PayrollActions } from '..'

interface UpcomingContentProps {
  upcomingPayroll: UpcomingPayroll
}

const UpcomingContent = ({
  upcomingPayroll
}: UpcomingContentProps) => {
  const { t } = useTranslation(['common', 'payrolls'])

  let message = t('someTimeLeftTitle', { ns: 'payrolls' })
  let subMessage = t('someTimeLeftSubtitle', { ns: 'payrolls' })

  const showPayrollCannotBeCreatedMessage = () => {
    if (upcomingPayroll.payrollCreated)
      return false
    
    if (upcomingPayroll.earliestPayrollCreationDate != null) {
      if (new Date() < new Date(upcomingPayroll.earliestPayrollCreationDate)) {
        return true
      }
    }
    return false
  }
  
  return (
    <>
      <PayrollHeader
        labelText={t('upcomingPayday', { ns: 'payrolls' })}
        paymentDate={upcomingPayroll.paymentDate}
      />
      <StatusMessage
        message={message}
        subMessage={subMessage}
        latestSubmitDateIntro={t('latestSubmitDateIntro', { ns: 'payrolls' })}
        latestSubmitDate={formatDateString(upcomingPayroll.latestPayrollFileSubmitDate)}
        payrollCreationMessage={upcomingPayroll.payrollCreated ? t('payrollCreatedIntro', { ns: 'payrolls' }) : undefined}
        payrollCreationDate={upcomingPayroll.payrollCreated ? formatDateString(upcomingPayroll.payrollCreateDate) : undefined}
        earliestPayrollCreationMessage={showPayrollCannotBeCreatedMessage() 
          ? t('payrollProcessingCanBeStartedAtIntro', { ns: 'payrolls' }) 
          : undefined}
        earliestPayrollCreatedDate={showPayrollCannotBeCreatedMessage() 
          ? formatDateString(upcomingPayroll.earliestPayrollCreationDate) 
          : undefined}
      />
      <ImportFilesForPayday
        upcomingPayroll={upcomingPayroll}
      />
      <PayrollActions
        upcomingPayroll={upcomingPayroll}
      />
    </>
  )
}

export default UpcomingContent
